import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MediaObserver } from '@ngbracket/ngx-layout';
import {
  L10N_CONFIG,
  L10N_LOCALE,
  L10nConfig,
  L10nLocale,
  L10nTranslatePipe,
  L10nTranslationService
} from 'angular-l10n';
import { Subscription, timer } from 'rxjs';
import { oase_config } from '../../environments/environment';
import { APIConfigService } from "../api.config.service";
import { AngularMaterial2Module } from "../app.module.material";
import { Kernbenutzer } from '../protected/kernbenutzer/kernbenutzer.model';
import { KernbenutzerPasswordChangeComponent } from "../protected/kernbenutzer/kernbenutzer.passwordChange.component";
import { Data } from "../providers/data";
import { AuthService } from './auth.service';
import { ErrorHelper } from "./error.helper";
import { Lieferant } from './lieferant.model';
import { LoggerService } from './logger.service';
import { Kernantwort } from './response/kernantwort.model';

const PATH_FILE = 'app/shared/header.component.ts';
const OBJ_LNG_NAME = 'benutzer';
const BACKEND_PATH_PREFIX = 'benutzerdaten/';

@Component({
  selector: 'oase-header',
  templateUrl: './header.component.html',
  standalone: true, imports: [AngularMaterial2Module, L10nTranslatePipe]

})
export class HeaderComponent {
  OBJ_LNG_NAME = OBJ_LNG_NAME; // Wird benötigt das Konstanten nicht im Template refernziert werden können.
  @Output() sidenavEmitter = new EventEmitter();


  private sessionTimeoutSubscription: any = null;
  sessionTimeoutColor: string = 'primary';
  sessionLeftTime: number;
  sessionMaxTime: number;
  appVersion: string = oase_config.appversion;
  aktuell: Kernbenutzer = new Kernbenutzer();
  fehler: Kernantwort = null;
  isdialogopen: boolean = false;
  ladedaten: boolean = true;
  dialogrunningajaxcall: boolean = false;
  lieferant: Lieferant;
  subscription: Subscription;

  ngOnInit() {
    this.sessionMaxTime = this.authService.getMaxTimeSec();
    this.sessionLeftTime = this.authService.getMaxTimeSec();
    let timerObj = timer(1000, 1000); // Jede Sekunde
    this.sessionTimeoutSubscription = timerObj.subscribe((t: any) => {
      this.sessionTimeoutExecuted();
    });

    this.subscription = this._dataService.lieferant$.subscribe(item => this.lieferant = item);
  }

  private sessionTimeoutExecuted(): void {
    let currentDate: Date = new Date();
    this.sessionLeftTime = this.authService.getLeftTimeSec(currentDate);
    if (this.sessionLeftTime <= (this.sessionMaxTime * 10 / 100)) // Bei weniger als 10% Zeit
      this.sessionTimeoutColor = 'warn';
    else if (this.sessionLeftTime <= (this.sessionMaxTime * 25 / 100)) // Bei weniger als 25% Zeit
      this.sessionTimeoutColor = 'accent';
    else
      this.sessionTimeoutColor = 'primary';
  }

  ngOnDestroy() {
    // unsubscribe the subscription in ngDestroy
    if (this.sessionTimeoutSubscription != null)
      this.sessionTimeoutSubscription.unsubscribe();
    this.subscription.unsubscribe();
  }

  constructor(
    public authService: AuthService,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    @Inject(L10N_CONFIG) private config: L10nConfig,
    public translation: L10nTranslationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public apiConfigService: APIConfigService,
    public http: HttpClient,
    private _logger: LoggerService,
    public media: MediaObserver,
    private _dataService: Data
  ) {
    this._logger.debug(PATH_FILE+' - header constructor');
    this.getLieferantDaten();
  }

  private getLieferantDaten() {
    this._logger.log(PATH_FILE + ' - getLieferantDaten Begin');
    this.authService.logTokenInfos(PATH_FILE + ' - getLieferantDaten');
    this.http.get<Lieferant>(this.apiConfigService.REST_API_BASE() + 'lieferant/get').subscribe({
        next: (data) => {
          this._dataService.changeLieferant(data);
        },
        error: (err) => ErrorHelper.handleError(err, "Fehler beim holen des Lieferanten", this._logger, this.translation),
        complete: () => this._logger.log(PATH_FILE + ' - Holen des Lieferanten abgeschlossen')
    });
  }

  zeigePasswortMaske() {
    this._logger.log(PATH_FILE + ' - zeigePasswortMaske BEGIN');
    this.aktuell = JSON.parse(JSON.stringify(this.authService.getBenutzerdaten()));
    this._logger.log(PATH_FILE + ' - zeigePasswortMaske this.aktuell: ', JSON.parse(JSON.stringify(this.aktuell)));

    const dialogRefEdit = this.dialog.open(KernbenutzerPasswordChangeComponent, {
      width: '600px',
      data: {
        aktuell: this.aktuell,
        OBJ_LNG_NAME: this.OBJ_LNG_NAME,
        BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
        neu: false,
      }
    });

    dialogRefEdit.afterClosed().subscribe((elemEdited: boolean) => {
      if (elemEdited) {
        this.speichernPwd();
      }
    });

  }


  speichern(kernbenutzer: Kernbenutzer, snacknachricht: string) {
    this._logger.log(PATH_FILE + ' - speichern BEGIN');
    this._logger.log(PATH_FILE + ' - speichern - kernbenutzer: ', JSON.parse(JSON.stringify(kernbenutzer)));

    this.dialogrunningajaxcall = !!this.isdialogopen;

    this.authService.updateBenutzerdaten(kernbenutzer)
      .subscribe({
        next: (data) => {
          this._logger.log(PATH_FILE + ' - got answer data: ', data);
          this.ladedaten = false;
          this.openSnackBar(snacknachricht);
          this._logger.log(PATH_FILE + ' - speichern End');
        },
        error: (err) => {
          this.ladedaten = false;
          ErrorHelper.handleError(err, "Fehler beim speichern (bearbeiten) des Kern_Benutzer", this._logger, this.translation);
        }
      });
  } // speichern

  speichernAend() {
    this._logger.log(PATH_FILE + ' - speichernAend BEGIN');
    this._logger.log(PATH_FILE + ' - speichernAend this.aktuell: ', JSON.parse(JSON.stringify(this.aktuell)));

    let snacknachricht = this.translation.translate('allgemein.daten.geändert', { typ: this.translation.translate(OBJ_LNG_NAME + '.typ') });
    this.speichern(this.aktuell, snacknachricht);
  } // speichernAend

  speichernPwd() {
    this._logger.log(PATH_FILE + ' - speichernPwd BEGIN');
    this._logger.log(PATH_FILE + ' - speichernPwd this.aktuell: ', JSON.parse(JSON.stringify(this.aktuell)));

    let snacknachricht = this.translation.translate('allgemein.daten.geändert', { typ: this.translation.translate(OBJ_LNG_NAME + '.passwort') });
    this.speichern(this.aktuell, snacknachricht);
  } // speichernPwd

  isAuth(): boolean {
    return this.authService.isAuthenticated();
  }

  onLogout() {
    this.authService.logout();
  }

  toggleSidenav() {
    this.sidenavEmitter.emit();
  }

  markDialogAsOpen() {
    this._logger.log(PATH_FILE + ' - markDialogAsOpen');
    this.fehler = null;
    this.isdialogopen = true;
  }

  markDialogAsClosed() {
    this._logger.log(PATH_FILE + ' - markDialogAsClosed');
    this.leereHelper();
    this.isdialogopen = false;
  }

  isDialogOpen() {
    return this.isdialogopen;
  }

  leereHelper(resetForms: boolean = true) {
    this._logger.log(PATH_FILE + ' - leereHelper BEGIN');
    this.aktuell.passwort = null;
    this.aktuell.passwortwiederholung = null;
    this.aktuell = new Kernbenutzer();
    this.fehler = null;
    this.dialogrunningajaxcall = false;
    if (resetForms) {
      /*
            Funktioniert zur Zeit noch nicht, vermutlich muss das Formular von ngForm auf FormGroup (siehe SignIn) umgebaut werden
            this.insertedit.rest();
            this.editPwd.rest();
            this.delete.rest();
      */
    }
  }

  getPasswortStaerke(passwort: string = ""): string {
    return this.translation.translate('allgemein.validierung.passwort.');
  }

  getTitle() {
    return this.translation.translate(OBJ_LNG_NAME + '.title') + ' - ' + this.translation.translate('project.title');
  }

  openSnackBar(message: string, action: string = null) {
    this.snackBar.open(message, action, { duration: 5 * 1000 });
  }

}
